import React, {
    Component
} from 'react';
import * as Config from '../config/Config';
import * as User from '../helpers/User';
import * as Common from '../helpers/Common';
import Contentproceed from './contractpartials/Contentproceed';
import Decline from './contractpartials/Decline';
export default class Contracts extends Component {
    constructor(props) {
        super(props);
        this.goToThanksPage = this.goToThanksPage.bind(this);
        this.state = {
            contract: [],
            proceedBlock: true
        };
    }
    getContract(id) {
        Common.reactLoader("show", "Please wait...");
        fetch(Config.domainUrl + 'contracts/' + id, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Common.getTokenData()
            }
        }).then((response) => response.json()).then((responseJson) => {
            if (responseJson.status == 1) {
                this.setState({
                    contract: responseJson.data,
                    proceedBlock: true
                });
                Common.composcroll();
                Common.contentResizeLoad();
                Common.showSmallLeftMenu();
            }
            Common.reactLoader("hide");
        });
    }
    backToComponentList() {
        const {
            data
        } = this.props;
        this.props.switchback('component_list', data.learning_room_id, data.dlr_id);
    }
    declineBlock() {
        this.setState({
            proceedBlock: false
        })
        Common.composcroll();
        Common.contentResizeLoad();
    }
    continueContract() {
        const {
            data
        } = this.props;
        this.getContract(data.id);
    }
    declineContract() {
        const {
            data
        } = this.props;
        let query_data = {
            comp_id: data.id,
            learner_id: User.UserId(),
            compseq_id: data.compseq_id,
            lroom_id: data.learning_room_id,
            divider_id: data.divider_id,
            dlrid: data.dlr_id
        };
        window.swal({
            //title: 'Attention!',
            text: 'Are you sure want to proceed this action?',
            //type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#14a430',
            cancelButtonColor: '#0082c9',
            animation: false,
            confirmButtonText: 'Ok'
        }).then((result) => {
            if (result) {
                Common.reactLoader("show", "Please wait...");
                fetch(Config.domainUrl + 'contracts/decline', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + Common.getTokenData()
                    },
                    body: JSON.stringify(query_data)
                }).then((response) => response.json()).then((responseJson) => {
                    Common.reactLoader("hide");
                    if (responseJson.status == 2) {
                        if(this.props.usableType=="webapp"){
                            Common.clearUserData();
                            window.location = window.location+"/#/login";
                        }
                    }
                });
            }
        });
    }
    componentDidMount() {
        const {
            data
        } = this.props;
        this.getContract(data.id);
    }
    goToThanksPage() {
        const {
            data
        } = this.props;
        this.props.returnthanks({
            "status": "completed",
            "learning_room_id": data.learning_room_id,
            "compseq_id": data.compseq_id,
            "divider_id": data.divider_id,
            "dlr_id": data.dlr_id,
            "learner_id": data.learner_id,
            "is_ag": data.is_ag,
            "id": data.id,
            "compo_type": "thanks",
            "look_before": data.compseq_id,
            "flowresult": true
        });
    }

  render() {

    let contract=this.state.contract;
    const {data,usableType}=this.props;

    return (
     <div className="main-inner">

<div className="border-box">

 <div className={contract.base_line?"title-box":"title-box tit-new"}>
 <div title="Contract" className="ct_complete_button"></div>
 <h6>{contract.contract_name?contract.contract_name:''}</h6><span>{contract.base_line?contract.base_line:''}</span>
</div>

<div  >
{
 this.state.proceedBlock?<Contentproceed data={data} usableType={usableType} contract={contract} backToComponentList={(e)=>this.backToComponentList()} declineBlock={(e)=>this.declineBlock()} />:<Decline usableType={usableType} continueContract={(e)=>this.continueContract()} declineContract={(e)=>this.declineContract()}
 goToThanksPage={this.goToThanksPage} />
}

</div>

<div>
</div>

</div>
</div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/lr_dlr_components/Contracts.js